<button
   type="button"
   class="lcs-spin-button-increment"
   tabindex="-1"
   [attr.aria-label]="incrementText"
   (click)="onIncrementClick()"
   mat-icon-button
>
   <mat-icon>keyboard_arrow_up</mat-icon>
</button>

<div
   role="spinbutton"
   tabindex="0"
   [attr.aria-valuenow]="value"
   [attr.aria-valuetext]="valueText || null"
   [attr.aria-valuemin]="valueMin"
   [attr.aria-valuemax]="valueMax"
   [attr.aria-label]="name"
   (keydown)="onKeydown($event)"
>
   <ng-content></ng-content>
</div>

<button
   type="button"
   class="lcs-spin-button-decrement"
   tabindex="-1"
   [attr.aria-label]="decrementText"
   (click)="onDecrementClick()"
   mat-icon-button
>
   <mat-icon>keyboard_arrow_down</mat-icon>
</button>
